<template>
  <!-- Notice with images -->
  <div @click="noticeEvent('showNotice')">
    <block-title
      @noticeEvent="noticeEvent"
      noHiding="true"
      :message="message"
    />
    <div class="categoryDiv">
      <img
        v-if="message.category === 'eco'"
        class="categoryIcon"
        src="@/assets/sustainability_sml.png"
      />
      <img
        v-if="message.category === 'pta'"
        class="categoryIcon"
        src="@/assets/pta_sml.png"
      />
      <i
        v-if="message.category === 'general'"
        style="font-size: 17px; opacity: 0.5; vertical-align: text-bottom"
        class="far fa-newspaper"
      ></i>
      <i
        v-if="message.category === 'sports'"
        style="font-size: 17px; opacity: 0.5; vertical-align: text-bottom"
        class="fas fa-futbol"
      ></i>
      <!-- <img
        v-if="message.category === 'general'"
        class="categoryIcon"
        src="@/assets/general_sml.png"
      /> -->
      <img
        v-if="message.category === 'travel'"
        class="categoryIcon"
        src="@/assets/travel_sml.png"
      />
      {{ message.category }}
      <span class="yearBlock pull-right" v-if="message.years">
        Years:
        <b>{{ message.years }}</b>
      </span>
      <span
        class="yearBlock pull-right"
        v-if="!message.years && !message.class_label"
      >
        Years:
        <b>All</b>
      </span>
      <span class="yearBlock pull-right" v-if="message.class_label">
        <b>{{ message.class_label }}</b>
      </span>
    </div>
    <!-- v-if='message.images.length > 1' -->
    <div
      v-if="message.extras.date"
      class="blockText noticeText eventMiddle"
      style="position: relative"
    >
      <p style="text-align: center; padding: 10px">
        &nbsp;&nbsp;
        <span style="letter-spacing: 1px">
          <b>{{ message.title }}</b>
        </span>

        <br />
        <b class="eventDate">
          <i class="far fa-calendar-alt" style="margin-bottom: 8px"></i>
          {{ message.extras.date }}
        </b>
      </p>
      <div class="insideRect"></div>
    </div>
    <div
      class="limitedDiv"
      v-if="message.message != '<p></p>' && message.message != ''"
    >
      <p
        class="blockText noticeText limitedText"
        style="text-align: left;"
        v-html="message.message"
      ></p>
    </div>
    <div>
      <span class="seeMoreLabel" style="margin-bottom: 10px">See more</span>
    </div>

    <div
      class="row equal"
      v-if="message.images && message.images.length > 2 && !message.extension"
    >
      <div class="col-xs-7 nopadding" style="margin-left: -3px">
        <div class="bigimg">
          <img :src="message.images[0]" />
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-xs-5 nopadding">
        <div
          class="smallimg"
          style="margin-bottom: 2px"
          :style="{ 'background-image': 'url(' + message.images[1] + ')' }"
        >
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
        <div
          class="smallimg"
          :style="{ 'background-image': 'url(' + message.images[2] + ')' }"
        >
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div
      class="row equal"
      v-if="message.images && message.images.length == 2 && !message.extension"
    >
      <div class="col-xs-6 nopadding" style="margin-left: -3px">
        <div class="bigimg">
          <img :src="message.images[0]" />
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-xs-6 nopadding">
        <div
          class="smallimg"
          style="height: 100%"
          :style="{ 'background-image': 'url(' + message.images[1] + ')' }"
        >
          <i class="fa fa-picture-o" aria-hidden="true"></i>
        </div>
      </div>
    </div>

    <div
      v-if="message.images && message.images.length == 1 && !message.extension"
    >
      <div class="bigimg oneImage">
        <img :src="message.images[0]" />
        <i class="fa fa-picture-o" aria-hidden="true"></i>
      </div>
    </div>
    <div
      v-if="
        message.images &&
        message.images.length == 2 &&
        message.extension == 'gif'
      "
    >
      <div class="bigimg oneImage">
        <img :src="message.images[1]" />
        <i class="fas fa-circle gifPlayIcon">
          <span>GIF</span>
        </i>
      </div>
    </div>
    <div
      class="videoPoster"
      v-if="
        message.images &&
        message.images.length == 2 &&
        message.extension == 'mp4'
      "
      style="margin: -10px"
    >
      <img
        v-if="message.images[1]"
        :src="message.images[1]"
        style="width: 100%; height: auto; margin-bottom: 15px"
      />
      <i class="fas fa-play-circle videoPlayIcon"></i>
      <!-- <video width="100%" height="auto"  controls="true" preload="metadata" poster="{{ message.images[1] }}" style="max-height: 360px;">
      <source src="{{ message.images[0] }}" type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'>
      Your browser does not support the video tag.
      </video>-->
    </div>
    <!-- <div class="socialLinks" v-if="message.extras.showSocial">
      <div class="row">
        <a
          class="btn btn-link"
          target="_blank"
          href="https://www.instagram.com/homerunapp/?hl=en"
          @click='openUrl($event, "https://www.instagram.com/homerunapp/?hl=en")'
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          class="btn btn-link"
          target="_blank"
          href="https://twitter.com/HomeRunTeam?lang=en"
          @click='openUrl($event, "https://twitter.com/HomeRunTeam?lang=en")'
        >
          <i class="fab fa-twitter"></i>
        </a>
        <a
          class="btn btn-link"
          target="_blank"
          href="https://www.facebook.com/HomeRunSchools/"
          @click='openUrl($event, "https://www.facebook.com/HomeRunSchools/")'
        >
          <i class="fab fa-facebook-f"></i>
        </a>
        <a
          class="btn btn-link"
          target="_blank"
          href="https://www.linkedin.com/company/homerunapp/"
          @click='openUrl($event, "https://www.linkedin.com/company/homerunapp/")'
        >
          <i class="fab fa-linkedin-in"></i>
        </a>
      </div>
    </div>-->
    <div
      class="institution"
      v-if="message.user_type != 3 && message.user_type != 5"
    >
      <img src="@/assets/triangle.png" class alt />
      <div class="logo">
        <img v-if="message.school_logo" :src="message.school_logo" alt />
      </div>
    </div>
    <NoticeFooter
      :message="message"
      :user_id="user_id"
      :disableChat="true"
      @noticeEvent="noticeEvent"
    />
    <div style="clear: both"></div>
  </div>
</template>
<style scoped></style>
<script>
import BlockTitle from "@/components/noticeTypes/other/BlockTitle";
import NoticeFooter from "@/components/noticeTypes/other/NoticeFooter";
export default {
  name: "noticeimages",
  components: {
    BlockTitle,
    NoticeFooter,
  },
  props: {
    message: Object,
    user_id: Number,
  },
  methods: {
    noticeEvent(type) {
      this.$emit("noticeEvent", {
        action: type,
        id: this.message.notice_user_id,
        user_id: this.message.user_id,
      });
    },
  },
  mounted() {
    // console.log(this.message);
  },
};
</script>
